import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck, Store, Package, Loader2 } from "lucide-react";
import api, { imageUrl, money } from "@/lib/api";
import { StatusBadge, STATUS_META, ALL_STATUSES } from "@/components/OrderStatus";
import { Footer } from "@/components/Footer";

const flow = ["pending", "accepted", "preparing", "ready", "out_for_delivery", "completed"];

export default function Orders() {
  const [orders, setOrders] = useState(null);

  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)); }, []);

  if (!orders) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="animate-spin text-[#1A3C2A]" /></div>;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-10 min-h-[70vh]">
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#1A3C2A] mb-6">My orders</h1>
      {orders.length === 0 ? (
        <div className="text-center py-20">
          <Package size={40} className="text-[#1A3C2A] mx-auto" />
          <p className="font-display text-xl font-bold text-[#1A3C2A] mt-3">No orders yet</p>
          <Link to="/browse" className="text-sm font-semibold text-[#E07A5F] mt-1 inline-block">Start shopping</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => {
            const idx = flow.indexOf(o.status);
            return (
              <div key={o.id} data-testid={`order-${o.id}`} className="bg-white border border-[#E5DEC9] rounded-2xl p-4 sm:p-5">
                <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                  <div>
                    <p className="font-display font-bold text-[#1A3C2A]">{o.order_number}</p>
                    <p className="text-xs text-[#5A626A]">{new Date(o.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })} · {o.seller_name}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    {o.payment_status !== "paid" && <span className="text-xs font-semibold px-2 py-1 rounded-full bg-red-50 text-red-600">Unpaid</span>}
                    <StatusBadge status={o.status} testid={`order-status-${o.id}`} />
                  </div>
                </div>
                <div className="flex gap-2 mb-3 overflow-x-auto no-scrollbar">
                  {o.items.map((li, i) => (
                    <img key={i} src={imageUrl(li.image)} alt={li.name} title={`${li.quantity}× ${li.name}`} className="w-14 h-14 rounded-lg object-cover bg-[#F4EFE6] shrink-0" />
                  ))}
                </div>
                {o.status !== "cancelled" && (
                  <div className="flex items-center gap-1 mb-3">
                    {flow.map((s, i) => (
                      <div key={s} className={`h-1.5 flex-1 rounded-full ${i <= idx ? "bg-[#1A3C2A]" : "bg-[#E5DEC9]"}`} />
                    ))}
                  </div>
                )}
                <div className="flex items-center justify-between text-sm">
                  <span className="text-[#5A626A] flex items-center gap-1">
                    {o.fulfilment === "delivery" ? <><Truck size={14} /> Delivery</> : <><Store size={14} /> Collection</>}
                  </span>
                  <span className="font-display font-bold text-[#1A3C2A]">{money(o.total)}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="mt-16"><Footer /></div>
    </div>
  );
}
